export default __webpack_public_path__ + "static/media/img_services04.229889e7.png";